import Element3 from 'element3'
import 'element3/lib/theme-chalk/index.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

createApp(App).use(router).use(Element3).mount('#app')
